import React from 'react';
import './index.css';
import App from './components/app';
import { createRoot } from 'react-dom/client';
import * as serviceWorker from './serviceWorker';

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(<App />);
}

serviceWorker.unregister();
